<div class="conn-card">
    <app-report-top-filter-bar
        [paraReportName]="'merchant-payout-report'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
    ></app-report-top-filter-bar>

    <div class="grid summary-cards-row">
        <div class="col-12 md:col-3">
            <div class="summary-card">
                <span class="summary-card-label">Total Sales</span>
                <span class="summary-card-value">{{ summary.totalSales | currency | currencySpacing }}</span>
            </div>
        </div>
        <div class="col-12 md:col-3">
            <div class="summary-card">
                <span class="summary-card-label">Total Orders</span>
                <span class="summary-card-value">{{ summary.totalOrders }}</span>
            </div>
        </div>
        <div class="col-12 md:col-3">
            <div class="summary-card">
                <span class="summary-card-label">Total Platform Fees Collected</span>
                <span class="summary-card-value">{{ summary.totalPlatformFeesCollected | currency | currencySpacing }}</span>
            </div>
        </div>
        <div class="col-12 md:col-3">
            <div class="summary-card">
                <span class="summary-card-label">Total Net Earnings / Payout</span>
                <span class="summary-card-value">{{ summary.totalNetPayout | currency | currencySpacing }}</span>
            </div>
        </div>
    </div>

    <div class="active-customer-filter" *ngIf="activeCustomerFilter">
        <span class="pi pi-filter"></span>
        Showing orders for <strong>{{ activeCustomerFilter.name }}</strong>
        <button
            pButton
            pRipple
            type="button"
            label="Clear"
            icon="pi pi-times"
            class="p-button-text p-button-sm"
            (click)="clearCustomerFilter()"
        ></button>
    </div>

    <br />

    <p-table
        #dt
        [tableStyle]="{ width: 'max-content' }"
        [value]="displayList"
        *ngIf="displayList?.length > 0"
        [autoLayout]="true"
        responsiveLayout="scroll"
        [paginator]="false"
        [customSort]="true"
        (onLazyLoad)="customSort($event)"
        [lazy]="true"
        [rows]="rows"
        showLoader="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders"
        [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
        selectionMode="single"
    >
        <ng-template pTemplate="header">
            <tr>
                <th *ngIf="isDetailView" pSortableColumn="orderNumber" style="text-align: center">
                    Order # <p-sortIcon field="orderNumber"></p-sortIcon>
                </th>
                <th pSortableColumn="customerName" style="text-align: center">
                    Customer Name <p-sortIcon field="customerName"></p-sortIcon>
                </th>
                <th *ngIf="isDetailView" pSortableColumn="orderDate" style="text-align: center">
                    Order Date <p-sortIcon field="orderDate"></p-sortIcon>
                </th>
                <th pSortableColumn="totalAmountPaid" style="text-align: center">
                    Total Amount Paid <p-sortIcon field="totalAmountPaid"></p-sortIcon>
                </th>
                <th style="text-align: center">Payment Gateway Fee</th>
                <th style="text-align: center">Platform Fee</th>
                <th style="text-align: center">Refund</th>
                <th pSortableColumn="netPayout" style="text-align: center">
                    Net Payout <p-sortIcon field="netPayout"></p-sortIcon>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item" class="text-center">
                <td *ngIf="isDetailView" style="text-align: center">{{ item.orderNumber }}</td>
                <td style="text-align: center">
                    <a
                        *ngIf="!isDetailView"
                        class="customer-name-link"
                        pTooltip="View all orders for this customer"
                        (click)="filterByCustomer(item)"
                    >{{ item.customerName }}</a>
                    <span *ngIf="isDetailView">{{ item.customerName }}</span>
                </td>
                <td *ngIf="isDetailView" style="text-align: center">{{ item.orderDate | date : "LLL dd, YYYY" }}</td>
                <td style="text-align: center">{{ item.totalAmountPaid | currency | currencySpacing }}</td>
                <td style="text-align: center">{{ item.paymentGatewayFee | currency | currencySpacing }}</td>
                <td style="text-align: center">{{ item.platformFee | currency | currencySpacing }}</td>
                <td style="text-align: center">{{ item.refundAmount | currency | currencySpacing }}</td>
                <td style="text-align: center">{{ item.netPayout | currency | currencySpacing }}</td>
            </tr>
        </ng-template>

        <ng-template pTemplate="footer">
            <tr *ngIf="displayList?.length > 0">
                <td *ngIf="isDetailView" style="text-align: center"></td>
                <td style="text-align: center"><strong>Total</strong></td>
                <td *ngIf="isDetailView" style="text-align: center"></td>
                <td style="text-align: center">{{ calculateSummaryTotal("totalAmountPaid") }}</td>
                <td style="text-align: center">{{ calculateSummaryTotal("paymentGatewayFee") }}</td>
                <td style="text-align: center">{{ calculateSummaryTotal("platformFee") }}</td>
                <td style="text-align: center">{{ calculateSummaryTotal("refundAmount") }}</td>
                <td style="text-align: center">{{ calculateSummaryTotal("netPayout") }}</td>
            </tr>
        </ng-template>
    </p-table>

    <div class="flex" *ngIf="displayList?.length == 0">
        <div class="text-align-center" style="width: 100%">
            <span class="control-description text-muted text-align-center">No data found!</span>
        </div>
    </div>

    <div class="flex py-2" *ngIf="displayList?.length > 0">
        <p class="bold">
            <span class="bold text-surface-300">Note:</span>
            <span class="text-gray-600">
                Net Payout = Order Total − Payment Gateway Fee − Platform Fee − Refund Amount. Full and partial
                refunds do not automatically recalculate the platform fee — any fee adjustment on a refunded order
                is applied manually by an administrator.
            </span>
        </p>
    </div>

    <p-paginator
        *ngIf="dataList?.length > 0"
        [first]="first"
        (onPageChange)="onPageChange($event)"
        [rows]="rows"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Page: {currentPage} of {totalPages}, Total Records: {totalRecords}"
        #p
    >
    </p-paginator>
</div>
